
import * as React from 'react';
import { IItemHoverCardProps, itemHoverCardControl } from '../../controls/itemHoverCardControl';
import { IItemCache } from '../../models/IItemCacheObserver';
import { fileNameFacet, folderFacet, analyticsItemFacet } from '../../facets/ItemFacets';
import { oneNoteFacet } from '../../facets/DocumentFacets';
import { enableFileHoverCardConfigurationFacet, configurationItemKey } from '../../facets/ConfigurationFacets';

class NoHoverZone extends React.PureComponent<IItemHoverCardProps> {
  public render(): JSX.Element {
    return (
      <>
        { this.props.children }
      </>
    );
  }
}

export function getItemHoverCard(itemCache: IItemCache, props: {
  itemKey: string | undefined;
}): React.ComponentType<IItemHoverCardProps> | undefined {
  const {
    itemKey
  } = props;

  const controlHandler = itemCache.demandItemFacet(itemHoverCardControl, itemKey);

  const {
    hoverCard,
    isAvailable: isHoverCardAvailable
  } = itemHoverCardControl.evaluate(controlHandler)(itemCache, {
    itemKey: itemKey,
    // The final impelmentation of the HoverCard must be supplied by an add-on via a control handler.
    hoverCard: NoHoverZone,
    isAvailable: isHoverCardEnabled(itemCache, {
      itemKey
    })
  });

  return isHoverCardAvailable && hoverCard ? hoverCard : undefined;
}

function isHoverCardEnabled(itemCache: IItemCache, props: {
  itemKey: string | undefined;
}): boolean {
  const {
    fileName,
    folder,
    analyticsKey,
    oneNote
  } = itemCache.demandItem({
    fileName: fileNameFacet,
    folder: folderFacet,
    analyticsKey: analyticsItemFacet,
    oneNote: oneNoteFacet
  }, props.itemKey);

  const enableFileHoverCard = itemCache.demandItemFacet(enableFileHoverCardConfigurationFacet, configurationItemKey);

  const itemAnalyticsKey = analyticsKey && analyticsKey.itemKey;
  const extension = fileName && fileName.extension;

  return !!(enableFileHoverCard && extension && itemAnalyticsKey && !folder && !oneNote);
}
